"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.stripLandingAttribution = exports.LANDING_ATTRIBUTION_PARAMS = void 0;
exports.sendPingback = sendPingback;
exports.appendPartnerCookies = appendPartnerCookies;
// Dependency-free, so safe for the browser bundle (ramp.js imports it here).
var landing_attribution_1 = require("./landing-attribution");
Object.defineProperty(exports, "LANDING_ATTRIBUTION_PARAMS", { enumerable: true, get: function () { return landing_attribution_1.LANDING_ATTRIBUTION_PARAMS; } });
Object.defineProperty(exports, "stripLandingAttribution", { enumerable: true, get: function () { return landing_attribution_1.stripLandingAttribution; } });
/**
 * Sends a pingback to the reporting system using the most reliable method available.
 * Uses navigator.sendBeacon as the primary transport — this ensures delivery even if
 * the user closes or navigates away from the page. Falls back to fetch with keepalive
 * if sendBeacon is unavailable or its queue is full.
 */
function sendPingback(url) {
    const urlString = typeof url === "string" ? url : url.toString();
    if (navigator.sendBeacon?.(urlString))
        return;
    fetch(urlString, { method: "POST", keepalive: true, mode: "no-cors" }).catch(() => { });
}
/**
 * First-party advertising-partner cookies forwarded onto pingback URLs so
 * partner conversion APIs can attribute the user. Add a new entry here to
 * forward an additional cookie everywhere pingbacks are built.
 *
 *  - `_fbc`, `_fbp` — Facebook
 *  - `_scid`        — Snapchat
 */
const PARTNER_COOKIES = ["_fbc", "_fbp", "_scid"];
function getCookie(name) {
    const escaped = name.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
    const match = document.cookie.match(new RegExp(`(?:^|;\\s*)${escaped}=([^;]*)`));
    if (match?.[1] === undefined)
        return undefined;
    try {
        return decodeURIComponent(match[1]);
    }
    catch {
        return match[1];
    }
}
/**
 * Appends any partner cookies present on the current page as query parameters
 * to the given URL. Existing params with the same name are preserved.
 */
function appendPartnerCookies(url) {
    for (const name of PARTNER_COOKIES) {
        const value = getCookie(name);
        if (value && !url.searchParams.has(name)) {
            url.searchParams.set(name, value);
        }
    }
    return url;
}
